export enum DashboardTypeEnum {
    MONITORING = 'monitoring',
    STATISTICS = 'statistics',
}
